import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ButtonGroup from './ButtonGroup';
import Button from './Button';
import DataElement from './DataElement';
import TextElement from './TextElement';
import { Select, Option } from './Select';
import './InExcludeSelect.css';
import * as helpers from '../support/Helpers';

InExcludeSelect.propTypes = {
  availableItems: PropTypes.array,
  className:      PropTypes.string,
  // help:           PropTypes.string,
  // mode:           PropTypes.oneOf(['all', 'none', 'include', 'exclude']),
  // items:          PropTypes.array,
  allItem:        PropTypes.array,
  value:          PropTypes.object,
  placeholder:    PropTypes.string,
  noneText:       PropTypes.string,
  onChange:       PropTypes.func,
  layout:         PropTypes.oneOf(['horizontal', 'vertical', 'responsive']),
  // disabled:    PropTypes.bool,
}

InExcludeSelect.defaultProps = {
  // mode: 'all',
  // items: [],
  defaultMode: 'all',
  defaultItems: [],
  value: {},
  allItems: [],
  placeholder: 'Select items to include/exclude',
  noneText: 'None',
  onChange: () => {},
  layout: 'responsive',
  // help:    '',
}

function InExcludeSelect(props) {

  const {
    defaultMode,
    defaultItems,
    value, // { mode, items },
    allItems,
    className,
    // help,
    placeholder,
    noneText,
    onChange,
    layout,
  } = props;

  // console.log("INEXCLUDESELECT", value);
  const [mode, setMode] = useState(value?.mode || defaultMode);
  const [items, setItems] = useState(value?.items || defaultItems);
  // console.log("INEXCLUDESELECT", mode, items);

  // useEffect(() => {
  //   // console.log("INEXCLUDESELECT useEffect", mode, items);
  //   if (mode === 'all' || mode === 'none') {
  //     onChange({mode});
  //   } else {
  //     onChange({mode, items});
  //   }
  // }, [mode, items]);

  const isFirstRender = React.useRef(true);

  useEffect(() => {
    // console.log("INEXCLUDESELECT useEffect", mode, items);
    // Only run this effect on updates, not on the first render
    // Running everytime caused on issue on the NewProject page. When the
    // setting button was clicked (after a file was loaded), would cause the
    // setting to get updated and the reparse button would become active.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (mode === 'all' || mode === 'none') {
      onChange({mode});
    } else {
      onChange({mode, items});
    }
  }, [mode, items]);


  const localOnChange = ({ value, attribute }) => {
    if (attribute === 'mode') {
      setMode(value); 
    }
    if (attribute === 'items') {
      setItems(value);
    }
  };

  const tempKlass = (mode === 'all' || mode === 'none') ? 'hidden' : '';

  const klass = classNames( "InExcludeSelect", className,
    'layout-' + layout,
   );

  // The select options are either an array of strings or an object with keys and values
  const values = helpers.convertToObject(allItems);
  const keys = (Array.isArray(allItems)) ? allItems.map( v => v.toString()) : Object.keys(values);
  const itemOptions = keys.map( k => <Option key={k} value={k}>{values[k]}</Option> );

  let listOrSelect;
  if (mode === 'include' || mode === 'exclude') {
    listOrSelect =
        <Select mode='tags' value={items}
          allowClear
          className={tempKlass}
          disabled={mode === 'all' || mode === 'none'}
          placeholder={placeholder}
          onChange={(value) => {
            localOnChange({attribute: 'items', value});
          }}
        >
          {itemOptions}
        </Select>
  } else if (mode === 'none') {
    listOrSelect = <div className='select-none'>{noneText}</div>
  } else if (mode === 'all') {
    listOrSelect =
        <TextElement className='select-all legend-by-key-group scroll-skinny'>{allItems.join(', ')}</TextElement>
  }

  return (
    <>
      <div className={klass} >
        <ButtonGroup>
          <Button width='60px'
            active={mode === 'all'}
            onClick={() => localOnChange({attribute: 'mode', value: 'all'})}
          >All</Button>
          <Button width='60px'
            active={mode === 'none'}
            onClick={() => localOnChange({attribute: 'mode', value: 'none'})}
          >None</Button>
          <Button width='60px'
            active={mode === 'include'}
            onClick={() => localOnChange({attribute: 'mode', value: 'include'})}
          >Include</Button>
          <Button width='60px'
            active={mode === 'exclude'}
            onClick={() => localOnChange({attribute: 'mode', value: 'exclude'})}
          >Exclude</Button>
        </ButtonGroup>
        {listOrSelect}
      </div>
    </>
  )
}

// Values are the same if the mode is the same and
// if the mode is 'exclude' or 'include', the items must be the same as well
InExcludeSelect.valuesEqual = (a, b) => {
  if (a.mode !== b.mode) { return false; }
  if (['include', 'exclude'].includes(a.mode)) {
    if (a.items.length !== b.items.length) { return false; }
    for (const item of a.items) {
      if (!b.items.includes(item)) { return false; }
    }
  }
  return true;
}

export default InExcludeSelect;
